<template>
    <div class="panel panel-offset" >
        <div class="panel-heading green-bg">
            <h3 class="panel-title">{{evaluationTitle}}</h3>
        </div>
        <div class="panel-body" v-if="canContribute">
            <tabs>
                <tab v-for="evaluation in evaluationList"
                :key="evaluation.evaluationSourceId" v-bind:header="evaluation.sourceName">
                    <div v-bind:class="{ 'has-error': errors.has('isContributing') }">
                        <div class="form-group">
                            <label class="col-md-3 control-label">Contributing Component</label>
                            <div class="col-md-3">
                                <select name="isContributing" class="form-control" v-model="evaluation.isContributing" v-validate="'required'">
                                    <option value="" disabled>Select a value</option>
                                    <option value=true>Contributing</option>
                                    <option value=false>Not Contributing</option>
                                    <option value=null>Unevaluated</option>
                                </select>
                                <span v-show="errors.has('isContributing')" class="has-error">Contrib Component is required</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-group" v-if="evaluation.evaluationSourceId === 4" v-bind:class="{ 'has-error': errors.has('concurred') }">
                        <label class="col-md-2 control-label">Concurred</label>
                        <div class="col-md-3">
                            <select name="concurred" v-model="evaluation.concurredId" class="form-control" v-validate="'required'">
                                <option disabled value ="">Select a value</option>
                                <option v-for="concurredType in concurredList" v-bind:value="concurredType.concurredId" :key="concurredType.concurredId">
                                    {{concurredType.description}}
                                </option>
                            </select>
                            <span v-show="errors.has('concurred')" class="has-error">Concurred is required</span>
                        </div>
                    </div>
                    <div class="form-group" v-if="isLimitedEval || evaluation.isContributing === true || evaluation.isContributing === 'true'">
                        <label class="col-md-2 control-label">Effect</label>
                        <div class="col-md-2">
                            <select name="effect" class="form-control" v-model="evaluation.effectId">
                                <option disabled value="">Select a value</option>
                                <option v-for="effect in effectList" v-bind:value="effect.effectId">
                                    {{effect.description}}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group" v-if="isLimitedEval">
                        <label class="col-md-2 control-label">Discuss Condition and Integrity</label>
                        <div class="col-md-10">
                            <textarea name="justification" class="form-control" v-model="evaluation.justification" style="width:750px" rows="6" />
                        </div>
                    </div>
                    <div class="form-group" v-if="currentUserEvaluationSourceEnum.includes(evaluation.evaluationSourceId)">
                        <button class="col-md-2 btn btn-primary" v-on:click="saveEligibility(evaluation.evaluationSourceId)">Save Evaluation</button>
                    </div>
                </tab>
            </tabs>
        </div>
        <div class="panel-body" v-else>
            Head of Segment is ineligibile.
        </div>
    </div>
</template>

<script>
import loggingService from '@/services/util/loggingService'
import evaluationService from '@/services/siteForm/evaluationService'
import validationResultDisplay from '@/components/ValidationResultDisplay.vue'
import roleService from '@/services/roleService.js'
import userService from '@/services/userService'
import workflowService from '@/services/workflowService'
import culturalResourceRecordingService from '@/services/culturalResourceRecordingService'
import { mapState } from 'vuex'
import { tab, tabs } from 'vue-strap'

export default {
    name: 'segmentEvaluation',
    components: {
        validationResultDisplay,
        tab,
        tabs
    },
    data: function () {
        return {
            isLoading: false,
            isDebug: false,
            eligibilityTypeList: [],
            effectList: [],
            evaluationList: [],
            disabledStyle: {
                'pointer-type': 'None',
                'opacity': 0.4
            },
            validationResult: [],
            currentWorkflowStatus: {},
            concurredList: evaluationService.ConcurredList,
            crrWfsEnum: culturalResourceRecordingService.WorkflowStatusEnum
        }
    },
    props: {
        segmentHead: {},
        culturalResource: {},
        onEvaluationSave: {},
        segHeadEval: {},
        isQaqc: { default: false },
        isConsultantSubmitted: { default: true },
        isAgencySubmitted: { default: true },
        hasAgencyAccess: { default: false },
        hasShpoAccess: { default: false },
        isConditionReport: { default: false },
        isInternalReview: { default: false },
        isNormalization: { default: false }
    },
    mounted () {
        this.log(`SegmentEvaluation mounted`)
    },
    computed: {
        canContribute: function () {
            return !!this.segHeadEval && this.segHeadEval.eligibilityId === evaluationService.EligibilityEnum.Eligible
        },
        evaluationTitle: function () {
            return ((this.segmentHead) ? 'Contributing Component to ' + this.segmentHead.siteName : '')
        },
        isLimitedEval: function () {
            return this.isConditionReport || this.isInternalReview
        },
        // compute current user info
        ...mapState({
            shpoUserDto: state => state.auth.shpoUserDto
        }),
        currentUserEvaluationSourceEnum: function () {
            // set up consultant, agency, and shpo role lists
            var adminRoleList = [roleService.RoleEnum.Administrator, roleService.RoleEnum.ShpoAdministrator]
            var consultantRoleList = [roleService.RoleEnum.ConsultantUser]
            var agencyRoleList = [roleService.RoleEnum.BlmUser]
            var shpoRoleList = [
                roleService.RoleEnum.ShpoAdministrator,
                roleService.RoleEnum.ShpoCrApprovingUser,
                roleService.RoleEnum.ShpoCrDataEntryUser,
                roleService.RoleEnum.ShpoRcAdministrator,
                roleService.RoleEnum.ShpoRcApprovingUser,
                roleService.RoleEnum.ShpoRcDataEntryUser
            ]
            //add agency/shpo role to consultantRoleList if "isConsultantSubmitted" === false and has agency/shpo access
            if (!this.isConsultantSubmitted) {
                if (this.hasAgencyAccess) {
                    consultantRoleList.push(roleService.RoleEnum.BlmUser)
                }
                if (this.hasShpoAccess) {
                    consultantRoleList = shpoRoleList.concat(consultantRoleList)
                }
            }
            //add shpo role to agencyRoleList if "isAgencySubmitted" === false and has shpo access
            if (!this.isAgencySubmitted && this.hasShpoAccess) {
                agencyRoleList = shpoRoleList.concat(agencyRoleList)
            }
            if (this.shpoUserDto && !this.isQaqc) {
                // check current user's roleList is in one of the above role lists, assign appropriate Evaluation Source Enum
                if (userService.hasRoleCheck(this.shpoUserDto.roleList, adminRoleList)) {
                    // if user is site administrator, assign all source enums
                    return [
                        evaluationService.EvaluationSourceEnum.Consultant,
                        evaluationService.EvaluationSourceEnum.Agency,
                        evaluationService.EvaluationSourceEnum.SHPO,
                        evaluationService.EvaluationSourceEnum.Current
                    ]
                } else if (userService.hasRoleCheck(this.shpoUserDto.roleList, consultantRoleList)) {
                    // return empty [] if consultant submitted form
                    return (this.isConsultantSubmitted ? [] : [ evaluationService.EvaluationSourceEnum.Consultant ])
                } else if (userService.hasRoleCheck(this.shpoUserDto.roleList, agencyRoleList)) {
                    // return empty [] if agency submitted form
                    return (this.isAgencySubmitted ? [] : [ evaluationService.EvaluationSourceEnum.Agency ])
                } else if (userService.hasRoleCheck(this.shpoUserDto.roleList, shpoRoleList)) {
                    return [ evaluationService.EvaluationSourceEnum.SHPO, evaluationService.EvaluationSourceEnum.Current ]
                } else {
                    return []
                }
            } else {
                return []
            }
        }
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'Segment Evaluation', message)
        },
        loadEvaluations (crrId) {
            var searchDto = {culturalResourceRecordingId: crrId, associatedCulturalResourceId: this.segmentHead.culturalResourceId}
            return evaluationService.search(this.$http, searchDto).then(response => {
                if (response.data.length > 0) {
                    this.log('Found evaluations: ' + response.data.length)
                    this.evaluationList = response.data.map(x => {
                        x.sourceName = evaluationService.sourceName(x.evaluationSourceId)
                        if (x.isContributing === null) {
                            x.isContributing = 'null'
                        }
                        return x
                    })
                    this.log('Evaluation length: ' + this.evaluationList.length)
                    this.log('Checking workflow status: ' + this.currentWorkflowStatus.workflowStatusId)
                    // check current workflow status and create new agency/shpo evaluation list if necessary
                    switch (this.currentWorkflowStatus.workflowStatusId) {
                    // if currentWorkflowStatus is Pending Agency Approval,
                    // create new Agency eval only if current user has agency role and evaluationList has no existing Agency evaluation
                    case (culturalResourceRecordingService.WorkflowStatusEnum.PendingAgencyApproval):
                        this.checkSourceAndCreateEvaluation(evaluationService.EvaluationSourceEnum.Agency)
                        break
                    // if currentWorkflowStatus is Pending SHPO Approval,
                    // create new SHPO eval only if current user has shpo role and evaluationList has no existing shpo evaluation
                    case (culturalResourceRecordingService.WorkflowStatusEnum.PendingSHPOApproval):
                        if (!this.checkSourceAndCreateEvaluation(evaluationService.EvaluationSourceEnum.SHPO)) {
                            // if shpo eval is not created from the above, run the below
                            if (!this.isLimitedEval) {
                                this.checkSourceAndCreateEvaluation(evaluationService.EvaluationSourceEnum.Current)
                            }
                        }
                        break
                    default:
                        break
                    }
                } else {
                    this.log('creating new evaluation')
                    // create Initial evaluation
                    if (this.isInternalReview) {
                        var sourceEnum = this.currentWorkflowStatus.workflowStatusId <= this.crrWfsEnum.PendingAgencyApproval
                            ? evaluationService.EvaluationSourceEnum.Agency : evaluationService.EvaluationSourceEnum.SHPO
                        this.createEvaluation(sourceEnum)
                    // create SHPO evaluation if normalization, else create consultant eval
                    } else if (this.isNormalization) {
                        this.createEvaluation(evaluationService.EvaluationSourceEnum.SHPO)
                    } else {
                        this.createEvaluation(evaluationService.EvaluationSourceEnum.Consultant)
                    }
                }
                return response
            })
        },
        checkSourceAndCreateEvaluation (evaluationSourceId) {
            if ((this.currentUserEvaluationSourceEnum.includes(evaluationSourceId)) &&
            !(this.evaluationList.find(evaluation => { return evaluation.evaluationSourceId === evaluationSourceId }))) {
                this.createEvaluation(evaluationSourceId)
                // return true if new eval is created
                return true
            } else {
                // return false if no eval is created
                return false
            }
        },
        createEvaluation (evaluationSourceId) {
            var evaluationDto = {
                culturalResourceRecordingId: this.$route.params.culturalResourceRecordingId,
                isContributing: '',
                eligibilityId: '',
                effectId: '',
                evaluationSourceId: evaluationSourceId,
                associatedCulturalResourceId: this.segmentHead ? this.segmentHead.culturalResourceId : null,
                sourceName: evaluationService.sourceName(evaluationSourceId),
                justification: ''
            }
            if (this.canContribute) {
                this.log('found contributor, copy stuff from head')
                evaluationDto.eligibilityId = this.segHeadEval.eligibilityId
                evaluationDto.isEligibleA = this.segHeadEval.isEligibleA
                evaluationDto.isEligibleB = this.segHeadEval.isEligibleB
                evaluationDto.isEligibleC = this.segHeadEval.isEligibleC
                evaluationDto.isEligibleD = this.segHeadEval.isEligibleD
            }
            this.evaluationList.push(evaluationDto)
            //this.evaluation = evaluationDto
        },
        loadCurrentWorkflowStatus (crrId) {
            this.currentWorkflowStatus = {}
            var handle = this
            return workflowService.currentWorkflowStatusDto(handle.$http, workflowService.WorkflowEnum.CulturalResourceRecording, crrId)
                .then(function (response) {
                    handle.currentWorkflowStatus = response.data
                })
        },
        loadData () {
            var crrId = this.$route.params.culturalResourceRecordingId
            this.log(`Loading data. CR: ${this.culturalResource.culturalResourceId}`)
            // load current workflowstatus first so its data can be used in latter calls
            return Promise.all([this.loadCurrentWorkflowStatus(crrId)]).then(response => {
                Promise.all([this.loadEvaluations(crrId)]).then(response2 => {
                    this.loadLookups()
                })
            })
        },
        loadLookups () {
            this.eligibilityTypeList = evaluationService.EligibilityTypeList
            this.effectList = evaluationService.EffectList
        },
        saveEligibility (evaluationSourceId) {
            this.$validator.validateAll().then(result => {
                if (result) {
                    // flag to see if we need to sapwn and save a Current eval (on initial SHPO eval save, if SHPO eval is the same as Agency Eval)
                    var spawnAndSaveCurrent = false

                    // if saving SHPO evaluation
                    if (evaluationSourceId === evaluationService.EvaluationSourceEnum.SHPO) {
                        if (!(this.evaluationList.find(evaluation => { return evaluation.evaluationSourceId === evaluationService.EvaluationSourceEnum.Current }))) {
                            // no Current eval, set spawnAndSaveCurrent eval to true
                            spawnAndSaveCurrent = !this.isLimitedEval
                        }
                    }

                    var evaluation = this.evaluationList.find(e => { return e.evaluationSourceId === evaluationSourceId })
                    if (evaluation.isContributing === 'null') {
                        evaluation.isContributing = null
                    } else if (evaluation.isContributing === 'true') {
                        evaluation.isContributing = true
                    } else if (evaluation.isContributing === 'false') {
                        evaluation.isContributing = false
                    }
                    this.log('Save eligibility has been called for ' + evaluation.sourceName)
                    evaluationService.put(this.$http, evaluation).then(result => {
                        if (result.data.isValid) {
                            // if spawnCurrent is true, create Current eval using SHPO eval data and save eval
                            if (spawnAndSaveCurrent) {
                                //using JSON.stringify and JSON.parse to "copy" object without reference
                                var currentEval = JSON.parse(JSON.stringify(evaluation))
                                currentEval.evaluationSourceId = evaluationService.EvaluationSourceEnum.Current
                                currentEval.sourceName = evaluationService.sourceName(evaluationService.EvaluationSourceEnum.Current)
                                currentEval.concurredId = 1 //SHPO Concurred
                                //currentEval.justification = this.createCurentEvalJustification() //not needed
                                currentEval.evaluationInstanceId = 0

                                //save current evaluation
                                this.log('Saving Curent eval')
                                evaluationService.put(this.$http, currentEval).then(result2 => {
                                    if (result.data.isValid) {
                                        this.log('Current eval is saved')
                                    }
                                })
                            }
                            this.onEvaluationSave().then(response => {
                                this.loadData()
                            })
                        } else {
                            this.log('evaluation is INVALID, showing errors')
                            this.validationResult = result.data
                        }
                    })
                } else {
                    this.log('submit - invalid form')
                }
            })
        },
        createCurentEvalJustification () {
            var conJust = (this.evaluationList.find(e => { return e.evaluationSourceId === evaluationService.EvaluationSourceEnum.Consultant }) || {}).justification
            var agencyJust = (this.evaluationList.find(e => { return e.evaluationSourceId === evaluationService.EvaluationSourceEnum.Agency }) || {}).justification
            var shpoJust = (this.evaluationList.find(e => { return e.evaluationSourceId === evaluationService.EvaluationSourceEnum.SHPO }) || {}).justification

            var currentJust = ''
            if (conJust) currentJust = 'Consultant: ' + conJust + '\n\n'
            if (agencyJust) currentJust = currentJust + 'Agency: ' + agencyJust + '\n\n'
            if (shpoJust) currentJust = currentJust + 'SHPO: ' + shpoJust + '\n\n'
            return currentJust
        }
    }
}
</script>

<style>
    .inline {
        display: inline;
    }
</style>



// WEBPACK FOOTER //
// segmentEvaluation.vue?0bb46199